/**
 * DATA LAYER: INTERACTIVE CHAT OVERLAY
 * Se encarga de la comunicación HTTP con la API de Interactive Chat.
 */

export const ShowInteractiveMessage = async (text) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}interactivechat/show`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ text })
        });
        return { success: response.ok };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

export const HideInteractiveMessage = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}interactivechat/hide`, { method: 'POST' });
        return { success: response.ok };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

export const GetInteractiveChatConfig = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}interactivechat/config`);
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

export const SetInteractiveChatConfig = async (config) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}interactivechat/config`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(config)
        });
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data }; // incluye updatedAt
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

export const GetQuickReplies = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}interactivechat/replies`);
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data: data.data };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

export const SaveQuickReply = async (text) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}interactivechat/replies`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ text })
        });
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data: data.data };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

export const DeleteQuickReply = async (id) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}interactivechat/replies/${id}`, { method: 'DELETE' });
        return { success: response.ok };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

export const ReorderQuickReplies = async (orderedIds) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}interactivechat/replies/reorder`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(orderedIds)
        });
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: data.success };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};